import { Button } from '~/shared/ui/Button/Button';
import {
  cvaCalendarNav,
  cvaCalendarNavInner,
} from '~/pages/StartDatePage/ui/CalendarNav/CalendarNavStyles';
import { FC } from 'react';
import { useStartDateStore } from '~/shared/store/startDateStore';
import { formatDate } from '~/shared/utils/dateFormatter';

interface Props {
  date: Date;
  close: () => void;
}

export const CalendarNav: FC<Props> = ({ date, close }) => {
  const { actions } = useStartDateStore();
  const today = new Date();

  const startTodayHandler = () => {
    actions.setDate(today);
    close();
  };

  const startDayHandler = () => {
    actions.setDate(date);
    close();
  };

  return (
    <div className={cvaCalendarNav()}>
      <div className={cvaCalendarNavInner()}>
        <Button
          rubber
          variant={'noneBg'}
          size={'common'}
          onClick={startTodayHandler}>
          Начать с сегодня
        </Button>
        <Button
          rubber
          variant={'primary'}
          size={'common'}
          onClick={startDayHandler}>
          Начать с {formatDate(date)}
        </Button>
      </div>
    </div>
  );
};
